import { useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from 'stores/authStore';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';
import { removeBrand } from 'utils/brandService';

const useClearSession = () => {
  const queryClient = useQueryClient();
  const clearAuth = useAuthStore((state) => state.clearAuth);
  const clearSelectedProfile = useSelectedProfileStore((state) => state.clearSelectedProfile);

  return () => {
    clearAuth();
    clearSelectedProfile();
    removeBrand();
    queryClient.clear();
  };
};

export default useClearSession;
